/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Stat_Brokers_LinkedInputs */

const cs_import_stat_brokers_linked = /** @type {(inputs: Import_Stat_Brokers_LinkedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Makléři propojeni: ${i?.count}`)
};

const en_import_stat_brokers_linked = /** @type {(inputs: Import_Stat_Brokers_LinkedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Brokers linked: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Brokers linked: {count}" |
*
* @param {Import_Stat_Brokers_LinkedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_stat_brokers_linked = /** @type {((inputs: Import_Stat_Brokers_LinkedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Stat_Brokers_LinkedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_stat_brokers_linked(inputs)
	return cs_import_stat_brokers_linked(inputs)
});